import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Cookies from 'js-cookie';
import { BASE_URL } from '../http/http';
import axios from 'axios';
import TABnavigation from '../components/TABnavigation';
import RedirectButton from './RedirectButton';
import ClaimRewardsBanner from '../components/ClaimRewardsBanner';
import Leaderboard from '../components/Leaderboard/Leaderboard';

const Profile = () => {
  const [userAvatar, setuserAvatar] = useState({})
  const navigate = useNavigate();
  const msisdn = localStorage.getItem('msisdn')
// const redirectURL = localStorage.getItem('redirectUrl')
const token = localStorage.getItem('token')
const deviceId = localStorage.getItem('deviceId')
 const [isUnauthorized, setIsUnauthorized] = useState(false)
 const [showLeaderboard, setShowLeaderboard] = useState(false)
  
const handleLogout = async () => {
  try {
    await axios.post(
      `${BASE_URL}/api/v1/logout`,
      {}, // ✅ empty body
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Device-Id": deviceId,
          "User-Agent": navigator.userAgent
        }
      }
    );
  } catch (error) {
    // console.log("Logout API error (ignored):", error?.response?.status);
  } finally {
 localStorage.removeItem('msisdn');
localStorage.removeItem('redirectUrl');
localStorage.removeItem('currency');
localStorage.removeItem('token');
localStorage.removeItem('deviceId');

    navigate('/login');
  }
};

const getUserAvatar = async () => {
  try {
    if (!token) {
      // console.error("Token missing");
      return;
    }

    if (!deviceId) {
      // console.error("DeviceId missing");
      return;
    }

    // console.log('api ht--------------')

    const res = await axios.get(`${BASE_URL}/api/v1/profile?ani=${msisdn}`,{
      headers: {
        "Authorization": `Bearer ${token}`,
        "X-Device-Id": deviceId,
        "User-Agent":navigator.userAgent
      }
    });
    
    setuserAvatar(res.data);
  } catch (err) {
    // console.log(err)
     if (err.response?.status === 401) {
    // setIsUnauthorized(true);
    handleLogout()  
  }
    // console.log("STATUS:", err.response?.status);
    // console.log("ERROR:", err.response?.data);
  }
};
useEffect(() => {
  getUserAvatar()
}, [])


 
const navigateHandler = () => {
  
  const redirectURL = localStorage.getItem('redirectUrl');
    if (redirectURL) {
      window.location.href = redirectURL;
    } else {
      console.log("No redirect URL found");
    }

  };
  return (
   <div className="h-[100vh] bg-gradient-to-b from-[#253246] to-[#1e2738]">
    <div className={`h-full flex justify-start items-center relative flex-col ${showLeaderboard ? 'overflow-y-auto overflow-x-hidden block' : 'overflow-y-auto overflow-x-hidden'}`}>
      <div className={`w-full ${showLeaderboard ? 'max-w-full md:max-w-2xl lg:max-w-3xl' : 'max-w-md md:max-w-xl'} flex flex-col gap-4 md:gap-6 mx-auto`}>
        {/* Header */}
        <div className="px-10 py-6 flex items-center justify-between sticky top-0 bg-[#253246] z-50">
          <button 
            onClick={() => {
              if (showLeaderboard) setShowLeaderboard(false);
              else navigate("/auth");
            }} 
            className="text-xl bg-transparent border-2 border-white rounded-lg cursor-pointer w-10 h-10 flex items-center justify-center text-white"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <h1 className="text-3xl pr-4 text-white">{showLeaderboard ? "Hall of Fame" : "Profile"}</h1>
          {/* <div className="w-10"></div> Spacer for centering */}
        </div>

        {showLeaderboard ? (
          <div className="w-full pb-20">
            <Leaderboard />
          </div>
        ) : (
          <>
            {/* Profile Section */}
        <div className="px-6 py-6 flex items-center gap-4 sm:gap-6 w-full">
          <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden shrink-0 bg-[#1e2738] border-2 border-gray-600 flex items-center justify-center">
            {userAvatar?.imageUrl ? (
              <img 
                src={userAvatar?.imageUrl} 
                alt="" 
                className="w-full h-full object-cover"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            ) : (
              <span className="text-gray-400 text-xs">Avatar</span>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-white text-base sm:text-lg font-semibold mb-1 truncate">
              Hi, {msisdn}
            </h2>
            <p className="text-gray-300 text-sm sm:text-base mb-2 truncate">
              Level 3 Explorer I20 XRP
            </p>
            <button className="px-4 py-2 sm:px-6 bg-[#00D9FF] text-black border-none rounded text-sm sm:text-base font-semibold cursor-pointer whitespace-nowrap" onClick={()=>{navigate('/avatar')}}>
              myXR Avatar
            </button>
          </div>
        </div>

        {/* Claim Rewards Banner */}
        <div className="px-6 mb-2">
          <ClaimRewardsBanner />
        </div>

        {/* Menu Items */}
        <div className="px-10 mt-4">
          <div className="border-t border-gray-700">
            <button className="w-full text-left font-semibold py-4 text-white text-base  border-b border-gray-700 bg-transparent cursor-pointer" onClick={()=>{navigate('/auth')}}>
              Home
            </button>
            <button className="w-full text-left py-4 text-white text-base font-semibold border-b border-gray-700 bg-transparent cursor-pointer" onClick={() => setShowLeaderboard(true)}>
              Leaderboard
            </button>
            <button className="w-full text-left py-4 text-white text-base font-semibold border-b border-gray-700 bg-transparent cursor-pointer" onClick={()=>{navigate('/howitworks')}}>
              How It Works
            </button>
            <button className="w-full text-left py-4 text-white text-base font-semibold border-b border-gray-700 bg-transparent cursor-pointer" onClick={()=>{navigate('/terms')}}>
              Ts & Cs & FAQs
            </button>
              <button 
              onClick={handleLogout}
              className="w-full text-left py-4 text-white text-base font-semibold border-b border-gray-700 bg-transparent cursor-pointer"
            >
              Logout
            </button>
            <button 
              onClick={() => navigate("/unsubscribe")}
              className="w-full text-left py-4 text-white text-base font-normal border-b-2 border-[#00D9FF] bg-transparent cursor-pointer"
            >
              Unsubscribe
            </button>
          </div>
        </div>

        {/* Bottom Card */}
        <div className="mt-auto mx-6 mb-6 bg-white rounded-t-3xl px-6 pt-6 pb-6">
          <h2 className="text-3xl sm:text-4xl font-bold text-black text-center mb-2 leading-tight">
            Immersive<br />experiences
          </h2>
          <p className="text-sm sm:text-base text-gray-500 text-center mb-4 leading-relaxed">
            Join us on a journey where reality meets the virtual, and adventure knows no limits.
          </p>
          
          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mb-4">
            <div className="w-6 h-1 bg-[#00D9FF] rounded-full"></div>
            <div className="w-2 h-1 bg-gray-300 rounded-full"></div>
            <div className="w-2 h-1 bg-gray-300 rounded-full"></div>
          </div>

          <RedirectButton />
        </div>
        </>
        )}
        <TABnavigation navHandeler={navigateHandler}/>
      </div>
    </div>
    </div>
  );
};

export default Profile;